import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isReactElement = (data: any): data is React.ReactElement =>
  data instanceof Object && data.type !== undefined && data.props !== undefined && data.key !== undefined;
